module.exports = __webpack_public_path__ + "img/tab3.705fd1bf.png";